import styled from 'styled-components'

export const Button = styled.button`
  color: #fff;
  background: none;
  cursor: pointer;
`